export const profileConstants = {
 
  PROFILE_REQUEST: 'PROFILE_REQUEST',
  PROFILE_GET_SUCCESS: 'PROFILE_GET_SUCCESS',
  PROFILE_UPDATE_SUCCESS: 'PROFILE_UPDATE_SUCCESS',
  PROFILE_IMAGE_UPDATE_SUCCESS: 'PROFILE_IMAGE_UPDATE_SUCCESS',
  PROFILE_FAILURE: 'PROFILE_FAILURE',
};
